import { H1, PrimaryButton } from "@coherehealth/common";
import { QueueViewState } from "@coherehealth/qm-api";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Box } from "@mui/material";
import { NoCaseModal } from "components/DashboardPage/NoCaseModal";
import useLogout from "hooks/useLogout";
import routes from "routes";

export type QueueHomepageDisplayProps = {
  queueViewState: QueueViewState;
  canUseQM: boolean;
  hasPermission: boolean;
  loading: boolean;
  gettingActiveQueue?: boolean;
  children: React.ReactNode;
};

export const QmHomepageDisplay = ({
  queueViewState,
  canUseQM,
  hasPermission,
  loading,
  gettingActiveQueue,
  children,
}: QueueHomepageDisplayProps) => {
  const logout = useLogout();
  const showLoadingScreen = loading || gettingActiveQueue;
  return (
    <>
      {showLoadingScreen && (
        <Box display="flex" justifyContent="center" alignItems="center" sx={{ height: "100vh" }}>
          <CircularProgress />
        </Box>
      )}
      {canUseQM ? (
        hasPermission ? (
          queueViewState !== "NO_QUEUE" ? (
            children
          ) : (
            <NoCaseModal open headingText="No mapped queues, contact supervisor" queueViewState={queueViewState} />
          )
        ) : (
          <>
            <H1>Something went wrong, please check your permissions</H1>
            <PrimaryButton href={routes.DASHBOARD}>Back to dashboard</PrimaryButton>
          </>
        )
      ) : (
        <>
          <H1>Not Authorized</H1>
          <PrimaryButton onClick={() => logout()}>Logout</PrimaryButton>
        </>
      )}
    </>
  );
};
